import { IonCard, IonCardContent, IonBadge } from "@ionic/react";
import PostHeader from "../card/PostCard/PostHeader";
import PostBody from "../card/PostCard/PostBody";
import PostPoll from "../card/PostCard/PostPoll";
import PostRace from "../card/PostCard/PostRace";
import PostExam from "../card/PostCard/PostExam";
import { MessageBtn } from "../button/MessageBtn";
import PostIcons from "../card/PostCard/PostIcons";
import { PostMedia } from "./PostMedia";
import { useSelector } from "react-redux";
import Avatar from "../avatar/Avatar";
import {
  IonIcon,
  IonModal,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonList,
  IonItem,
  IonLabel,
  IonButtons,
  IonButton,
} from "@ionic/react";
import { useState } from "react";
import { heart } from "ionicons/icons";

export const FeedItem = ({ post, isReposted, index, replyOriginalPost }) => {
  const { _id, author } = useSelector((state) => state.currentProfile.data);
  const isPriority = index < 3; // Boost first 3 posts
  const [showLikesModal, setShowLikesModal] = useState(false);
  const isVideoOnly =
    post.media?.length === 1 && /\.(mp4|mov|avi)(\?.*)?$/i.test(post.media[0]);

  const handleCardClick = (e) => {
    const isButton = e.target.closest('button, ion-button, [role="button"]');
    if (isButton) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
  };
  const handleLikesClick = (e) => {
    e.preventDefault();
    e.stopPropagation(); // Stops the whole card from being clicked
    if (post.likes?.length > 0) setShowLikesModal(true);
  };
  // --- AGILE STEP 1: DYNAMIC LIKES TEXT LOGIC ---
  const renderLikesText = (likes) => {
    if (!likes || likes.length === 0) return null;

    if (likes.length === 1) {
      return (
        <>
          Liked by <strong>@{likes[0].username}</strong>
        </>
      );
    }

    if (likes.length === 2) {
      return (
        <>
          Liked by <strong>@{likes[0].username}</strong> and{" "}
          <strong>@{likes[1].username}</strong>
        </>
      );
    }

    // For 3 or more likes (e.g., "Liked by @rawdaYasser1 and 2 others")
    const remainingLikes = likes.length - 1;
    return (
      <>
        Liked by <strong>@{likes[0].username}</strong> and {remainingLikes}{" "}
        others
      </>
    );
  };
  // ----------------------------------------------
  const containerProps = isVideoOnly
    ? {
        // className: "post video-post display-flex ion-padding-horizontal"
        // routerLink: `/post/${post._id}`,
      }
    : {
        // className: `post display-flex ion-padding-horizontal${isReposted ? " post__repost" : ""}`,
        routerLink: `/post/${post._id}`,
        onClick: handleCardClick,
      };

  // Add border style for pinned or featured posts
  const isPinnedOrFeatured = post.isPinned || post.isFeatured;
  const isShort = post.body && post.body.length < 71;
  const hasMedia = post.media && post.media.length > 0;
  const hasExam = post.exam;
  const hasPoll =
    post.poll && post.poll.options && post.poll.options.length > 0;
  const hasRace = post.race && post.race.data && post.race.data.length > 0;
  const isShortContent =
    isShort && !hasMedia && !hasExam && !hasPoll && !hasRace;
  const cardStyle = post.isFeatured
    ? {
        // borderTop: "1px solid #a88008",
        // borderBottom: "1px solid #a88008",
        borderRadius: "0",
        boxShadow: "none",
      }
    : {
        borderRadius: "0",
        boxShadow: "none",
      };

  const cardContentStyle = isPinnedOrFeatured
    ? {
        background: post.isPinned
          ? "#fefbf4"
          : "linear-gradient(rgb(216, 6, 33) 10%, rgb(255, 255, 255) 40%)",
      }
    : {};

  const paddingX = {
    paddingLeft: isPinnedOrFeatured ? "0" : "16px",
    paddingRight: isPinnedOrFeatured ? "0" : "16px",
  };

  const postBottomContent = (
    <>
      {/* Optimized Media */}
      {post.media && (
        <PostMedia
          media={post.media}
          id={post._id}
          priority={isPriority}
          edgeToEdge={isPinnedOrFeatured}
        />
      )}

      <div
        className={isReposted && "display-none"}
        style={
          replyOriginalPost
            ? {}
            : isPinnedOrFeatured
              ? {
                  paddingLeft: "16px",
                  paddingRight: "16px",
                }
              : {
                  paddingLeft: "16px",
                  paddingRight: "16px",
                }
        }
      >
        {/* --- NEW: THE LIKES TRIGGER BUTTON --- */}
        {/* {post.likes?.length > 0 && (
            <div
              onClick={handleLikesClick}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                cursor: "pointer",
                marginTop: "8px",
              }}
            >
              <IonIcon
                icon={heart}
                color="danger"
                style={{ fontSize: "18px" }}
              />
              <span
                style={{
                  fontSize: "13px",
                  fontWeight: "bold",
                  color: "var(--ion-color-medium)",
                }}
              >
                {post.likes.length} {post.likes.length === 1 ? "Like" : "Likes"}
              </span>
            </div>
          )} */}
        {/* --- AGILE STEP 2: THE STYLED LIKES BUTTON WITH SMOOTH ANIMATION --- */}
        <div
          style={{
            // This wrapper controls the smooth slide-down animation
            maxHeight: post.likes?.length > 0 ? "60px" : "0px",
            opacity: post.likes?.length > 0 ? 1 : 0,
            marginTop: post.likes?.length > 0 ? "6px" : "0px",
            overflow: "hidden",
            transition: "all 0.3s ease-in-out",
          }}
        >
          <div
            onClick={handleLikesClick}
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "8px",
              cursor: "pointer",
              padding: "4px 6px",
              border: "1px solid #efefef",
              borderRadius: "8px",
              marginBottom: "0px",
            }}
          >
            <IonIcon icon={heart} color="danger" style={{ fontSize: "20px" }} />
            <span
              style={{
                fontSize: "14px",
                color: "#444",
              }}
            >
              {/* Safe to call, it returns null if empty */}
              {renderLikesText(post.likes)}
            </span>
          </div>
        </div>
        {/* -------------------------------------- */}

        <hr
          style={{
            width: "100%",
            margin: "0px auto 0px",
            background: "rgb(238, 238, 238)",
            height: "1px",
          }}
        />
        <PostIcons post={post} />
      </div>
    </>
  );

  return (
    <IonCard
      color="light"
      className={`${isShortContent ? "" : "post-card"} ion-no-margin ion-shadow-sm ion-no-padding bg-white`}
      {...containerProps}
      style={cardStyle}
    >
      <IonCardContent
        className="flex flex-col ion-no-padding"
        style={{
          ...cardContentStyle,
          paddingTop: "13px",
          paddingBottom: "6px",
        }}
      >
        <div className="flex align-items-stretch gap-2" style={paddingX}>
          {replyOriginalPost && (
            <div className="flex flex-col align-items-c gap-2">
              <Avatar
                username={post.author.username}
                avatar={post.author.avatar}
                province={post.author.province}
                size="md"
                className={isReposted && "display-none"}
              />
              <div
                style={{
                  height: "100%",
                  width: "1px",
                  backgroundColor: "#efefef",
                  flexGrow: 1,
                }}
              ></div>
            </div>
          )}
          <div
            style={{
              maxWidth: "100%",
              width: "100%",
            }}
          >
            <div
              className="flex gap-2"
              style={{
                marginLeft: isPinnedOrFeatured ? "16px" : "0",
                paddingRight: isPinnedOrFeatured ? "16px" : "0",
              }}
            >
              {!replyOriginalPost && (
                <Avatar
                  username={post.author.username}
                  avatar={post.author.avatar}
                  province={post.author.province}
                  size="md"
                  className={isReposted && "display-none"}
                  isFounder={post?.author?.isFounder}
                  isOfficial={post?.author?.isAdmin}
                />
              )}
              <PostHeader
                post={post}
                author={post.author}
                createdAt={post.createdAt}
                whiteText={post.isFeatured}
                allCaps={post.isFeatured && !post.author.avatar}
                isReposted={isReposted}
              />
            </div>

            <div
              className="flex flex-col justify-content-sb"
              style={{
                marginTop: "12px",
              }}
            >
              <div
                style={{
                  marginLeft: isPinnedOrFeatured ? "16px" : "0",
                  marginRight: isPinnedOrFeatured ? "16px" : "0",
                }}
              >
                <PostBody
                  body={post.body}
                  subject={post.subject}
                  // Reposts should show the original post
                  originalPost={
                    post.type === "repost" ? post.originalPost : null
                  }
                  noPadding={replyOriginalPost}
                />

                {/* Poll/Race/Exam components unchanged */}
                {post.poll?.options?.length > 0 && (
                  <PostPoll poll={post.poll} id={post._id} />
                )}
                {post.race?.data?.length > 0 && <PostRace race={post.race} />}
                {post.exam && <PostExam exam={post.exam} id={post._id} />}
              </div>
              {/* Footer unchanged */}
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                {post.isAd && post.author._id !== _id && (
                  <MessageBtn
                    userId={post.author._id}
                    query={`?post=${post._id}`}
                  />
                )}
              </div>
            </div>
            {replyOriginalPost ? postBottomContent : null}
          </div>
        </div>
        {!replyOriginalPost ? postBottomContent : null}
      </IonCardContent>

      {/* --- NEW: THE BOTTOM SHEET MODAL --- */}
      <IonModal
        isOpen={showLikesModal}
        onDidDismiss={() => setShowLikesModal(false)}
        initialBreakpoint={0.5}
        breakpoints={[0, 0.5, 0.75, 1]}
      >
        {/* 1. Added ion-no-border to remove the harsh line, and paddingTop to avoid the drag handle */}
        <IonHeader className="ion-no-border">
          <IonToolbar style={{ paddingTop: "12px" }}>
            <IonTitle style={{ fontWeight: "bold", fontSize: "18px" }}>
              Liked by
            </IonTitle>
            <IonButtons slot="end">
              <IonButton
                onClick={() => setShowLikesModal(false)}
                color="medium"
                style={{ fontWeight: "600" }}
              >
                Close
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>

        <IonContent>
          <IonList style={{ paddingTop: "0" }}>
            {post.likes?.map((user, i) => (
              <IonItem
                key={user._id || i}
                lines="full"
                button={true} // 2. Makes the entire row a clickable button!
                detail={false} // Removes the default right arrow icon
                routerLink={`/profile/${user.username}`} // Uses Ionic's native router instead of <Link>
                onClick={() => setShowLikesModal(false)} // Closes the modal when they click a user
                style={{
                  "--padding-top": "8px",
                  "--padding-bottom": "8px",
                }}
              >
                {/* 3. Added a wrapper div to give the Avatar breathing room */}
                <div style={{ marginRight: "14px" }}>
                  <Avatar
                    username={user.username}
                    avatar={user.avatar}
                    province={user.province}
                    isFounder={user.isFounder}
                    isOfficial={user.isAdmin}
                    size="md" // Optional: if your Avatar component supports sizes, 'sm' usually looks better in lists
                  />
                </div>

                <IonLabel>
                  <h2
                    style={{
                      fontWeight: "bold",
                      fontSize: "17px",
                      color: "var(--ion-text-color)", // Keeps it dark instead of link-red
                    }}
                  >
                    {user.username}
                  </h2>
                  {/* Optional: Show their province under their name for a richer UI */}
                  {user.province && (
                    <p
                      style={{
                        color: "gray",
                        fontSize: "14px",
                        marginTop: "2px",
                      }}
                    >
                      {user.province}
                    </p>
                  )}
                </IonLabel>
              </IonItem>
            ))}
          </IonList>
        </IonContent>
      </IonModal>
      {/* ----------------------------------- */}
      {/* <IonModal
        isOpen={showLikesModal}
        onDidDismiss={() => setShowLikesModal(false)}
        initialBreakpoint={0.5}
        breakpoints={[0, 0.5, 0.75, 1]}
      >
        <IonHeader>
          <IonToolbar>
            <IonTitle>Liked by</IonTitle>
            <IonButtons slot="end">
              <IonButton onClick={() => setShowLikesModal(false)}>
                Close
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <IonList>
            {post.likes?.map((user, i) => (
              <IonItem key={user._id || i} lines="full">
                <Avatar
                  username={user.username}
                  avatar={user.avatar}
                  province={user.province}
                  isFounder={user.isFounder}
                  isOfficial={user.isAdmin}
                />
                <IonLabel>
                  <Link to={`/profile/${user.username}`}>@{user.username}</Link>
                </IonLabel>
              </IonItem>
            ))}
          </IonList>
        </IonContent>
      </IonModal> */}
      {/* ----------------------------------- */}
    </IonCard>
  );
};

export default FeedItem;
